"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatEventName = void 0;
/**
 * Format event name to a common standard
 */
const formatEventName = (name) => {
    return name.toLocaleLowerCase().trim();
};
exports.formatEventName = formatEventName;
//# sourceMappingURL=event_schema_helper.js.map